import React, { useEffect } from 'react';
import styles from './Button.module.scss';
import ReactTooltip from 'react-tooltip';

type ButtonPreset = 'primary' | 'secondary' | 'success' | 'danger' | 'popover' | 'secondaryDanger' | 'primaryAlt' | 'white' | 'secondary-success' | 'disabled';

type ButtonSize = 'normal' | 'small' | 'extraSmall';

type Props = {
    text?: string;
    preset?: ButtonPreset;
    onlyIcon?: boolean;
    size?: ButtonSize;
    isDisabled?: boolean;
    isLoading?: boolean;
    bw?: boolean;
    disabledMessage?: string;
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

const Button: React.FC<Props> = ({ children, type, text, preset = 'primary', size, onlyIcon, isDisabled, isLoading, bw = true, disabledMessage, ...props }: Props) => {

    const presetClassName = preset ? styles[preset] : styles.primary;
    const sizeClassName = size ? (styles as any)['size' + size[0].toUpperCase() + size.substr(1, size.length)] : styles.sizeNormal;
    
    useEffect(() => {
        ReactTooltip.rebuild();
    }, [disabledMessage]);
    
    return (
        <>
            <button
                type={type || 'button'}
                {...props}
                onClick={e => {
                    if (isLoading|| isDisabled || props.disabled) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    else {
                        props.onClick && props.onClick(e);
                    }
                }}
                className={`${onlyIcon ? styles.buttonIcon : styles.button} ${presetClassName} ${sizeClassName} ${props.className || ''} ${isDisabled || props.disabled ? styles.disabled : ''} ${bw ? styles.bw : ''}`}
                data-for="btn-tooltip"
                data-tip={disabledMessage ? disabledMessage : null}
            >
                {isLoading && <div className={styles.buttonLoadingOverlay}>
                    <span className={styles.spinner}></span>
                </div>}
                {Boolean(text) && text}
                {children}
            </button>
            <ReactTooltip id="btn-tooltip" />
        </>

    );
}

export default Button;
